import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { AttendanceSummary, DAY_STATUS, days } from '../payroll.api';

/** The month's counts as coloured chips: present, half days, leave, absent, late marks, LOP. */
export default function AttendanceSummaryChips({ summary }: { summary: AttendanceSummary }) {
  const items: { label: string; value: number; bg: string; fg: string }[] = [
    { label: 'Working days', value: summary.workingDays, bg: '#F8FAFC', fg: '#334155' },
    { label: 'Present', value: summary.present, ...DAY_STATUS.PRESENT },
    { label: 'Half days', value: summary.halfDays, ...DAY_STATUS.HALF_DAY },
    { label: 'Paid leave', value: summary.paidLeave, ...DAY_STATUS.PAID_LEAVE },
    { label: 'Unpaid leave', value: summary.unpaidLeave, ...DAY_STATUS.UNPAID_LEAVE },
    { label: 'Absent', value: summary.absent, ...DAY_STATUS.ABSENT },
    { label: 'Holidays', value: summary.holidays, ...DAY_STATUS.HOLIDAY },
    { label: 'Weekly offs', value: summary.weeklyOffs, ...DAY_STATUS.WEEKLY_OFF },
    { label: 'Late marks', value: summary.lateMarks, bg: '#FFF7ED', fg: '#9A3412' },
    { label: 'LOP days', value: summary.lopDays, bg: '#FEE2E2', fg: '#7F1D1D' },
  ];
  return (
    <Stack direction='row' flexWrap='wrap' gap={1}>
      {items.map((i) => (
        <Chip
          key={i.label}
          label={`${i.label}: ${days(i.value)}`}
          sx={{ bgcolor: i.bg, color: i.fg, fontWeight: 600, border: '1px solid', borderColor: 'divider' }}
        />
      ))}
    </Stack>
  );
}
